// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Languages list */
.languages__list {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  list-style: none;
  margin: 0;
  padding: 0;
  align-items: flex-start;
  gap: var(--spacing-sm, 0.9375rem);
  align-self: stretch;
}

.languages__item-label {
  color: var(--color-text-subheading, var(--gray-900, #101828));
  font-size: var(--font-size-md, 1rem);
  font-weight: var(--font-weight-md, 500);
}

/* Empty state */
.languages__empty-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: var(--icon-xs, 1.5rem);
  height: var(--icon-xs, 1.5rem);
  flex-shrink: 0;
}

.languages__empty-icon svg {
  display: block;
  width: 100%;
  height: 100%;
}

:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .languages__item-label {
  font-size: var(--font-size-sm, 0.875rem);
}

@media (max-width: 576px) {
  .languages__item-label {
    font-size: var(--font-size-sm, 0.875rem);
  }
}

@container profile-pane (max-width: 576px) {
  .languages__item-label {
    font-size: var(--font-size-sm, 0.875rem);
  }
}
`, "",{"version":3,"sources":["webpack://./node_modules/profile-pane/lib/sections/languages/LanguageSection.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,oCAAoC;EACpC,uCAAuC;AACzC;;AAEA,gBAAgB;AAChB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE;IACE,wCAAwC;EAC1C;AACF","sourcesContent":["/* Languages list */\n.languages__list {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  align-items: flex-start;\n  gap: var(--spacing-sm, 0.9375rem);\n  align-self: stretch;\n}\n\n.languages__item-label {\n  color: var(--color-text-subheading, var(--gray-900, #101828));\n  font-size: var(--font-size-md, 1rem);\n  font-weight: var(--font-weight-md, 500);\n}\n\n/* Empty state */\n.languages__empty-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: var(--icon-xs, 1.5rem);\n  height: var(--icon-xs, 1.5rem);\n  flex-shrink: 0;\n}\n\n.languages__empty-icon svg {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .languages__item-label {\n  font-size: var(--font-size-sm, 0.875rem);\n}\n\n@media (max-width: 576px) {\n  .languages__item-label {\n    font-size: var(--font-size-sm, 0.875rem);\n  }\n}\n\n@container profile-pane (max-width: 576px) {\n  .languages__item-label {\n    font-size: var(--font-size-sm, 0.875rem);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
